import { useState } from 'react';
import '../styles/EndSection.css';

const endSectionContent = {
  swe: {
    title: 'Kontakt & information',
    intro: 'Vi finns här för att hjälpa dig vidare. Hör av dig till oss när det passar dig.',
    email: 'info@execora.se',
    phoneLabel: 'Telefon',
    phone: '+46 36 14 25 50',
    contactLabel: 'Kontakt',
    addressLabel: 'Adress',
    address: 'Fridhemsvägen 29, 553 02 Jönköping, Sverige',
    socialLabel: 'Sociala medier',
    social: [
      { name: 'LinkedIn', href: 'https://www.linkedin.com/company/profital-consulting/' }
    ],
    gdprLabel: 'GDPR',
    gdprTitle: 'GDPR-information',
    gdprText:
      'Vi behandlar personuppgifter enligt dataskyddsförordningen (GDPR). Uppgifter som delas via kontaktformulär eller mejl används endast för att hantera ärenden, kommunikation och relevanta rekryterings- eller bemanningsprocesser. Vi sparar inte personuppgifter längre än nödvändigt och delar dem inte med obehöriga tredje parter. Du har rätt att begära tillgång, rättelse eller radering av dina uppgifter.',
    close: 'Stäng'
  },
  eng: {
    title: 'Contact & information',
    intro: 'We are here to help you move forward. Feel free to contact us at any time.',
    email: 'info@execora.se',
    phoneLabel: 'Phone',
    phone: '+46 36 14 25 50',
    contactLabel: 'Contact',
    addressLabel: 'Address',
    address: 'Fridhemsvägen 29, 553 02 Jönköping, Sweden',
    socialLabel: 'Social media',
    social: [
      { name: 'LinkedIn', href: 'https://www.linkedin.com/company/profital-consulting/' }
    ],
    gdprLabel: 'GDPR',
    gdprTitle: 'GDPR information',
    gdprText:
      'We process personal data in accordance with the General Data Protection Regulation (GDPR). Information shared through contact forms or email is only used to handle inquiries, communication, and relevant recruitment or staffing processes. We do not store personal data longer than necessary and we do not share it with unauthorized third parties. You have the right to request access, correction, or deletion of your data.',
    close: 'Close'
  }
};

function EndSection({ lang = 'swe' }) {
  const [showGdpr, setShowGdpr] = useState(false);
  const text = endSectionContent[lang] || endSectionContent.swe;

  return (
    <>
      <footer className="end-section">
        <div className="end-section-inner">
          <h3 className="end-section-title">{text.title}</h3>
          <p className="end-section-intro">{text.intro}</p>

          <div className="end-section-grid">
            <div className="end-card">
              <span className="end-label">{text.contactLabel}</span>
              <a className="end-link" href={`mailto:${text.email}`}>
                {text.email}
              </a>
              <a className="end-link" href="tel:+4636142550">
                {text.phone}
              </a>
            </div>

            <div className="end-card">
              <span className="end-label">{text.addressLabel}</span>
              <p className="end-text">{text.address}</p>
            </div>

            <div className="end-card">
              <span className="end-label">{text.socialLabel}</span>
              <div className="end-social-list">
                {text.social.map((item) => (
                  <a
                    key={item.name}
                    className="end-link"
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <button type="button" className="gdpr-button" onClick={() => setShowGdpr(true)}>
            {text.gdprLabel}
          </button>
        </div>
      </footer>

      {showGdpr && (
        <div className="gdpr-overlay" onClick={() => setShowGdpr(false)}>
          <div className="gdpr-modal" onClick={(event) => event.stopPropagation()}>
            <h4 className="gdpr-title">{text.gdprTitle}</h4>
            <p className="gdpr-text">{text.gdprText}</p>
            <button type="button" className="gdpr-close" onClick={() => setShowGdpr(false)}>
              {text.close}
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default EndSection;
